module.exports = __webpack_public_path__ + "img/CNRS-logo.ce4f8a25.png";